export const controlMessages = {
  CLOSE_LIVE_SESSION_MESSAGE: 'Сессия завершена. Спасибо за просмотр!',
  CHANGE_LIVE_SESSION_MESSAGE: 'Трансляция завершена. Добро пожаловать на следующую сессию!',
}